import { Box, Col, Heading, Row, themes } from '@digitools/honest-react';
import React from 'react';
import useTranslate from '../../../hooks/useTranslate';
//@ts-ignore
import PhoneImg from '../contacts/Basic_Icons_Call.svg';
//@ts-ignore
import EmailImg from '../contacts/FileManagement_Icons_Mail.svg';
import ContactUsText from '../contacts/ContactUsText';
const ContactInfoBox = () => {
    const { t } = useTranslate();
    return (<Box style={{
            display: 'flex',
            marginTop: '1.5rem',
            borderLeft: `10px solid ${themes.rebrand.palette.primaryDark}`,
        }}>
      <Row>
        <Col sm={12} md={6} style={{ display: 'flex' }}>
          <PhoneImg aria-hidden='true' width='75' height='75' style={{
            height: '75px',
            marginLeft: '1rem',
            marginRight: '1rem',
            fill: `${themes.rebrand.palette.primaryDark}`,
        }}/>
          <p>
            <Heading style={{ fontWeight: 300, fontSize: '1.25rem' }} elemType={'h3'} elemStyle={'h5'}>
              {t(ContactUsText.phone)}
            </Heading>
            {t(ContactUsText.callUs)}
            <a className='font-weight-bold' href='tel:1-800-431-2958'>1-800-431-2958</a>
            <br />
            8:00am–8:00pm EST {t(ContactUsText.monday)}-{t(ContactUsText.thursday)}
            <br />
            8:00am–6:00pm EST {t(ContactUsText.friday)}
            <br />
          </p>
        </Col>
        <Col sm={12} md={6} style={{ display: 'flex' }}>
          <EmailImg aria-hidden='true' width='75' height='75' style={{ marginLeft: '1rem', marginRight: '1rem', fill: `${themes.rebrand.palette.primaryDark}` }}/>
          <p>
            <Heading style={{ fontWeight: 300, fontSize: '1.25rem' }} elemType={'h3'} elemStyle={'h5'}>
              Email
            </Heading>
            {t(ContactUsText.messageUs)}
            <a className='font-weight-bold' href='mailto:mylincolnportal_help@lfg.com'>mylincolnportal_help@lfg.com</a>
          </p>
        </Col>
      </Row>
    </Box>);
};
export default ContactInfoBox;
